



















import { Component, Prop, Vue } from 'vue-property-decorator'
import { UserInfo } from '@/interfaces/vuexStateInterface'
import { unbindWechat, bindWechatQrcode } from '@/apis/myInfo/myInfo.ts'
import {getMobilexdomain} from '@/utils/utils';
import i18n from '@/lang';

@Component({})
export default class WechatBind extends Vue {
  @Prop({default:'0',type:String}) open !:String;

  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo
  }
  private showCode: boolean = false
  private qrcode: string = ''
  
  bindWechat() {
    // 调用绑定微信接口
    if (!this.userInfo.openid) {
      this.showCode = true
      let secondDomain = getMobilexdomain();
      bindWechatQrcode({secondDomain:secondDomain})
        .then((res: any) => {
          this.qrcode = res.url
        })
        .catch((err:any) => {})
    } else {
      // 解除绑定
      unbindWechat()
        .then((res:any) => {
          this.$dialog.alert({ title: i18n.t('ktpMy.解除绑定成功') as string }).then(() => {
            this.$store.dispatch('setUserInfo').then(() => {
              this.$router.back()
            })
          })
        })
        .catch((err:any) => {})
    }
  }

  created() {
    this.$setNavInfo({
      type: 'normal',
      title: i18n.t('ktpMy.微信') as string,
      showTitle: true,
    })
    if(this.open == "1"){
      this.bindWechat();
    }
  }
}
